/* eslint-disable max-len */
import * as Blockly from 'blockly/core';

/**
 * Import JSDocs types 
 * @import {VmtFlyout} from 'blockly_vmt/vavanya-generator/src/vmt_blocks/building_blocks/fields/VmtFlyout/VmtFlyout';
 */

/**
 * Shared vmtFlyout for parameters and variables.
 * @type {VmtFlyout}
 * @private
 */
Blockly.Workspace.prototype.vmtFlyout_ = Blockly.Workspace.prototype.vmtFlyout_ || null;

/**
 * Get the shared vmtFlyout for parameters and variables.
 * @return {VmtFlyout} The shared vmtFlyout.
 */
Blockly.Workspace.prototype.getVmtFlyout = Blockly.Workspace.prototype.getVmtFlyout || function () {
    return this.vmtFlyout_;
};

/**
 * Get the topmost workspace in the workspace hierarchy.
 * @return {Blockly.Workspace}
 */
Blockly.Workspace.prototype.getTopWorkspace = Blockly.Workspace.prototype.getTopWorkspace || function () {
    let parent = this;
    while (parent.targetWorkspace) {
        parent = parent.targetWorkspace;
    }
    return parent;
};

/**
 * Shared vmtFlyout for parameters and variables.
 * @type {VmtFlyout}
 * @private
 */
Blockly.WorkspaceSvg.prototype.vmtFlyout_ = Blockly.WorkspaceSvg.prototype.vmtFlyout_ || null;

/**
 * Get the shared vmtFlyout for parameters and variables.
 * @return {VmtFlyout} The shared vmtFlyout.
 */
Blockly.WorkspaceSvg.prototype.getVmtFlyout = Blockly.WorkspaceSvg.prototype.getVmtFlyout || function () {
    return this.vmtFlyout_;
};

/**
 * Get the topmost workspace in the workspace hierarchy.
 * @return {Blockly.WorkspaceSvg}
 */
Blockly.WorkspaceSvg.prototype.getTopWorkspace = Blockly.WorkspaceSvg.prototype.getTopWorkspace || function () {
    let parent = this;
    while (parent.targetWorkspace) {
        parent = parent.targetWorkspace;
    }
    return parent;
};
